<template>
  <div>
    ForgotUsername page
  </div>
</template>

<script>
export default {
  name: 'ForgotUsername',
  data () {
    return {
      // some data
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/singIn/ForgotUsername/ForgotUsername.vue